module.exports = __webpack_public_path__ + "static/about-3-2235419558900ffdf40af9ab909ac0b6.jpg";